import { render, staticRenderFns } from "./Step5Overview.vue?vue&type=template&id=f027ecf4"
import script from "./Step5Overview.vue?vue&type=script&lang=js"
export * from "./Step5Overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports